import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  LoadCurrentUserNetworksFulfilledAction,
  LoadCurrentUserNetworksPendingAction,
  LoadCurrentUserNetworksRejectedAction,
} from '../../domains/currentUserNetworks/actions.types';

import { CurrentUserNetworks } from './types';

export type LoadCurrentUserNetworkAction =
  | LoadCurrentUserNetworksPendingAction
  | LoadCurrentUserNetworksFulfilledAction
  | LoadCurrentUserNetworksRejectedAction;

const initialState: CurrentUserNetworks = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<CurrentUserNetworks, LoadCurrentUserNetworkAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CURRENT_USER.LOAD_NETWORKS_PENDING': {
      return setPending();
    }
    case 'CURRENT_USER.LOAD_NETWORKS_FULFILLED': {
      return setFulfilled(action.payload.currentUserNetworks);
    }
    case 'CURRENT_USER.LOAD_NETWORKS_REJECTED': {
      return setRejected(action.payload.error);
    }
    default:
      return state;
  }
};

export default reducer;
